import {Routes} from '@angular/router'
import {ROUTE_SCRIPTS, ROUTE_SCRIPTS_HOME} from '../../application/constants'
import {superAuthGuard} from '../../application/auth.guard'

export default [
  {
    path: ROUTE_SCRIPTS,
    canActivate: [superAuthGuard],
    loadComponent: () => import('./scripts-screen-holder.component').then(c => c.ScriptsScreenHolderComponent),
    children: [
      {
        path: ROUTE_SCRIPTS_HOME,
        pathMatch: 'full',
        loadComponent: () =>
          import('./home/scripts-home.component').then(c => c.ScriptsHomeComponent)
      },
      {
        path: '**',
        redirectTo: ROUTE_SCRIPTS_HOME
      }
    ]
  }
] as Routes
